module.exports = __webpack_public_path__ + "assets/881a638ed907cd1db47fa8c3c4aee0e6.mp3";